import { config } from "../../config";
import { FeedFilter, FeedItem, FeedType } from "./data-types";

type FeedResult = {
    data?: Array<FeedItem>
    error?: string
}

export const feed = async (
    offset: number, 
    limit: number, 
    types: FeedType[], 
    filter: FeedFilter | null, 
    languages: string[],
    token?: string
): Promise<FeedResult> => {
    try {
        const authHeaders: {[key: string]: string} = {}
        if (token) {
            authHeaders['token'] = token!
        }

        const params: any = {
            offset,
            limit,
            type: types.join(',')
        }

        if (filter != null) {
            params.filter = filter
        }

        if (languages) {
            params.languages = languages.map(lng => lng.toUpperCase()).join(",")
        }

        console.log("Fetching")

        const res = await fetch(`${config.api.urlV1}/feed/?${new URLSearchParams(params).toString()}`, {
            method: 'GET',
            headers: {
                ...authHeaders,
                'Content-type': 'application/json',
            },
        })

        if (res.status !== 200) {
            const body = await res.json()

            return {
                error: body.error
            }
        }

        const body: Array<FeedItem> = await res.json()

        return {
            data: body,
        }
    } catch (e) {
        return {
            error: e as string
        }
    }
}
